export default "__VITE_ASSET__BnHpJNCW__"